import { KalturaRecordingType } from '@kaltura-ott/ott-client-types/api/types';

export interface RecordArgs {
  assetId: number;
  seriesId?: string;
  channelId?: number;
  epgId?: number;
  type?: KalturaRecordingType;
}

export enum DeleteRecordsTypesEnum {
  deleteAll = 'DELETE_ALL',
  deleteAllViewed = 'DELETE_ALL_VIEWED',
  deleteAllOlderTheOneWeek = 'DELETE_OLDER_THAN_ONE_WEEK',
}
